import React, { useContext } from "react";
import { Box, Paper, Typography, IconButton } from "@mui/material";
import LineItem from "./LineItemV2";
import LineItemEntryPopup from "./LineItemEntryPopupV3";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import AddStandardItemPopup from "../../../product/component/AddStandardItemPopup";
import CustomLineItemEntryPopup from "./CustomLineItemEntryPopup";
import StandardItem from "../../../product/component/StandardItem";
import EditIcon from "@mui/icons-material/Edit";
import { UserContext } from "../../../context/UserContext";

export default function LineItems(props) {
  const { user } = useContext(UserContext);
  const { items } = props;

  return (
    <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
      <Paper elevation={0} sx={{ minWidth: 0, maxWidth: "100%" }}>
        {(!items || items.length === 0) && (
          <Box p={2} py={4} sx={{ textAlign: "center" }}>
            <ShoppingBagOutlinedIcon sx={{ fontSize: "3rem", color: "#999" }} />
            <Typography variant="h5" gutterBottom>
              No items yet!
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Click the button below to add items
            </Typography>
          </Box>
        )}
        {items.map((o, idx) => (
          <Box pl={0.5} py={2} key={idx} sx={{ minWidth: 0 }}>
            <Box sx={{ display: "flex", gap: "1rem", alignItems: "flex-start", minWidth: 0 }}>
              <Box sx={{ flexGrow: 1, minWidth: 0, overflow: "hidden" }}>
                <LineItem item={o} view="min" />
              </Box>
              {!o.productId ? (
                <Box sx={{ flexShrink: 0 }}>
                  <CustomLineItemEntryPopup
                    item={o}
                    onChange={(o) => {
                      let arr = [...items];

                      if (!o) {
                        // delete
                        arr.splice(idx, 1);
                      } else {
                        arr[idx] = o;
                      }

                      props.onChange(arr);
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{ flexShrink: 0 }}>
                  <StandardItem
                    item={o}
                    onChange={(o) => {
                      let arr = [...items];

                      if (!o) {
                        // delete
                        arr.splice(idx, 1);
                      } else {
                        arr[idx] = o;
                      }

                      props.onChange(arr);
                    }}
                  >
                    <IconButton color="primary" size="small">
                      <EditIcon />
                    </IconButton>
                  </StandardItem>
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Paper>
      <Box mt={2} sx={{ display: "flex", gap: "10px", minWidth: 0, width: "100%" }}>
        <Box sx={{ flex: "1 1 0", minWidth: 0, overflow: "hidden" }}>
          <CustomLineItemEntryPopup
            idx={items.length}
            mode="add"
            onChange={(o) => {
              let arr = [...items];
              arr.push(o);
              props.onChange(arr);
            }}
          />
        </Box>
        <Box sx={{ flex: "1 1 0", minWidth: 0, overflow: "hidden" }}>
          <AddStandardItemPopup
            idx={items.length}
            onChange={(o) => {
              let arr = [...items];
              arr.push(o);
              props.onChange(arr);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
